const activeMenuEntry = document.querySelector('a[aria-current="page"]')

if (activeMenuEntry) {
  activeMenuEntry.classList.add("active")
}
